import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';

interface ObserveSiteUsage {
  siteName: string | null;
  stations: { id: string; name: string; installationId: string | null }[];
}

interface DeleteObserveSiteDialogProps {
  visible: boolean;
  usage: ObserveSiteUsage | null;
  busy: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

export const DeleteObserveSiteDialog = ({ visible, usage, busy, onHide, onConfirm }: DeleteObserveSiteDialogProps) => {
  const stations = usage?.stations ?? [];
  const sharedByMany = stations.length > 1;

  const footer = (
    <>
      <Button label={'Anuluj'} icon="pi pi-times" className="p-button-text" onClick={onHide} disabled={busy} />
      <Button
        label={'Usuń site'}
        icon="pi pi-trash"
        className="p-button-danger"
        onClick={onConfirm}
        disabled={busy || !usage?.siteName}
      />
    </>
  );

  return (
    <Dialog
      visible={visible}
      header={
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
          {"Usuwanie site'a w Cobrick Observe"}
        </span>
      }
      modal
      className="p-fluid"
      footer={footer}
      onHide={onHide}
      breakpoints={{ '896px': '90vw' }}
      style={{ maxWidth: '640px' }}
    >
      <div className="confirmation-content">
        <p>
          {'Site '}
          <strong>{usage?.siteName}</strong>
          {' zostanie usunięty w Cobrick Observe wraz z sekretem w AWS Secrets Manager. Operacja jest nieodwracalna — '}
          {'historia metryk i logów nie zostanie odzyskana.'}
        </p>

        {sharedByMany && (
          <Message
            severity="warn"
            text={`Site obsługuje ${stations.length} stanowiska tego samego systemu - wszystkie stracą telemetrię.`}
            className="p-mb-2 p-d-block"
          />
        )}

        <p className="p-mb-1">{'Stanowiska, które utracą powiązanie:'}</p>
        <ul>
          {stations.map((station) => (
            <li key={station.id}>
              {station.name}
              {station.installationId ? ` (${station.installationId})` : ''}
            </li>
          ))}
        </ul>

        <Message
          severity="warn"
          text={
            'Konfiguracja pojedzie na urządzenia brzegowe tych stanowisk od razu, nie dopiero przy kolejnej ' +
            'synchronizacji - to restartuje pyscaleo, więc trwające ważenie zostanie przerwane.'
          }
          className="p-mb-2 p-d-block"
        />
      </div>
    </Dialog>
  );
};
